export enum DataDisputeVRConnectionStatus {
  pendingNoConnect = 'notConnected',
  pendingWithConnect = 'connected',
  resolvedNoConnect = 'resolvedNoConnect',
  resolvedWithConnect = 'resolvedWithConnect',
}
